// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'


export const getAllDataOptionSites = createAsyncThunk('appUsers/getAllDataOptionSites', async id => {
  const response = await axios.get('https://apiv3dev.opentlv.com/api/v3/client/option/sites/all',  { params: { id} })
  return response.data
})

export const getDataOptionSites = createAsyncThunk('appUsers/getDataOptionSites', async params => {
  const response = await axios.get('https://apiv3dev.opentlv.com/api/v3/client/option/sites/data', {params})
  return {
    params,
    data: response.data.data,
    totalPages: response.data.total
  }
})

export const getUser = createAsyncThunk('appUsers/getUser', async id => {
  const response = await axios.get('https://apiv3dev.opentlv.com/api/v3/users/user', { params: { id} })
 // console.log(response.data)
  return response.data
})
export const addSiteToOption = createAsyncThunk('appUsers/addSiteToOption', async (option, { dispatch, getState }) => {
//  option.client_id = getState()
  console.log("addSite")
  
  option.option_id = getState().clientOptionSites.selectedOption.id
  console.log(option)

  console.log(getState().clientOptionSites.selectedOption)
  
  await axios.post('https://apiv3dev.opentlv.com/api/v3/client/addsitetooption', option)
  await dispatch(getDataOptionsClient(getState().sitesClient.params))

  //await d
})

export const addUser = createAsyncThunk('appUsers/addUser', async (user, { dispatch, getState }) => {
  await axios.post('/apps/users/add-user', user)
  await dispatch(getData(getState().users.params))
  await dispatch(getAllData())
  return user
})

export const deleteUser = createAsyncThunk('appUsers/deleteUser', async (id, { dispatch, getState }) => {
  await axios.delete('/apps/users/delete', { id })
  await dispatch(getData(getState().users.params))
  await dispatch(getAllData())
  return id
})

export const appClientsSlice = createSlice({
  name: 'appUsers',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedOption: null,
    selectedClient: null
  },
  reducers: {},
  extraReducers: builder => {
    builder
   
      .addCase(getAllDataOptionSites.fulfilled, (state, action) => {
        state.allData = action.payload.sites
        state.selectedOption = action.payload.option
        state.client = action.payload.client
        state.groupe = action.payload.groupe

      })
      .addCase(getDataOptionSites.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
      .addCase(getUser.fulfilled, (state, action) => {
        state.selectedUser = action.payload
      })
  }
})

export default appClientsSlice.reducer
